import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { UploadCloud, CheckCircle2 } from "lucide-react";

export default function UploadZone({ resume, fileInputRef, onUpload, disabled }) {
  const [drag, setDrag] = useState(false);

  const handleDrop = (e) => {
    e.preventDefault();
    setDrag(false);
    if (disabled) return;
    const file = e.dataTransfer.files[0];
    if (file) onUpload({ target: { files: [file] } });
  };

  return (
    <Box
      onClick={() => !disabled && fileInputRef.current?.click()}
      onDragOver={(e) => { e.preventDefault(); if (!disabled) setDrag(true); }}
      onDragLeave={() => setDrag(false)}
      onDrop={handleDrop}
      sx={{
        border: `2px dashed ${drag ? "#2563eb" : resume ? "#10b981" : "#cbd5e1"}`,
        borderRadius: "12px",
        p: 3,
        textAlign: "center",
        cursor: disabled ? "not-allowed" : "pointer",
        bgcolor: drag ? "#eff6ff" : resume ? "#f0fdf4" : "#f8fafc",
        opacity: disabled ? 0.55 : 1,
        transition: "all 0.2s ease",
        "&:hover": disabled ? {} : { borderColor: "#2563eb", bgcolor: "#eff6ff" },
      }}
    >
      <input ref={fileInputRef} hidden type="file" onChange={onUpload} accept=".pdf,.docx,.doc" disabled={disabled} />
      <Box sx={{
        width: 48, height: 48, borderRadius: "12px", mx: "auto", mb: 1.5,
        bgcolor: resume ? "#dcfce7" : "#e0e7ff",
        display: "flex", alignItems: "center", justifyContent: "center",
      }}>
        {resume
          ? <CheckCircle2 size={24} color="#10b981" />
          : <UploadCloud size={24} color="#2563eb" />}
      </Box>
      {resume ? (
        <>
          <Typography variant="body2" sx={{ fontWeight: 600, color: "#15803d" }}>{resume.name}</Typography>
          <Typography variant="caption" sx={{ color: "#64748b" }}>Click to replace</Typography>
        </>
      ) : (
        <>
          <Typography variant="body2" sx={{ fontWeight: 600, color: "#0f172a" }}>Drop your resume here</Typography>
          <Typography variant="caption" sx={{ color: "#64748b" }}>
            or click to browse · PDF, DOCX · Max 10MB
          </Typography>
        </>
      )}
    </Box>
  );
}
